import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Box, Link as MuiLink, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Details from "../componentsPeopletech/Details";
import Footer from "../componentsPeopletech/Footer/Footer";

const Contact = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || 'en';
  const baseUrl = 'https://www.peoplefortech.com';

  return (
    <>
      <Helmet>
        {/* Meta tags básicos */}
        <title>{t('nav.contact')} - PeopleForTech</title>
        <meta name="description" content={`${t('contact.title')} - ${t('contact.subtitle')}`} />
        <link rel="canonical" href={`${baseUrl}/contact`} />
        <html lang={currentLang} />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${baseUrl}/contact`} />
        <meta property="og:title" content={`${t('nav.contact')} - PeopleForTech`} />
        <meta property="og:description" content={`${t('contact.title')} - ${t('contact.subtitle')}`} />
        
        {/* Schema.org JSON-LD para SEO de IA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": `${t('nav.contact')} - PeopleForTech`,
            "description": `${t('contact.title')} - ${t('contact.subtitle')}`,
            "url": `${baseUrl}/contact`,
            "mainEntity": {
              "@type": "Organization",
              "name": "PeopleForTech",
              "url": baseUrl,
              "email": "contact@peoplefortech.com",
              "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Customer Service",
                "email": "contact@peoplefortech.com",
                "availableLanguage": ["en", "es", "pt", "fr", "de", "zh", "ar", "hi", "ru", "ja"]
              }
            },
            "inLanguage": currentLang
          })}
        </script>
      </Helmet>
      <Details />
      <Box sx={{ textAlign: "center", px: 2, mb: 3 }}>
        <Typography variant="body1" sx={{ color: "#111", mb: 1 }}>
          Si quieres leads desde IA, revisa primero nuestra guía GEO.
        </Typography>
        <MuiLink
          component={RouterLink}
          to="/geo-para-chatgpt-gemini"
          underline="hover"
          sx={{ fontWeight: 700, color: "#1e2a5a" }}
        >
          Ir a la página GEO para ChatGPT y Gemini
        </MuiLink>
      </Box>
      <Footer />
    </>
  );
};

export default Contact;
